declare const ScriptPubKeyBrand: unique symbol;
export type ScriptPubKey = string & { readonly [ScriptPubKeyBrand]: true };

declare const DomainIdBrand: unique symbol;
export type DomainId = number & { readonly [DomainIdBrand]: true };

const LOWERCASE_HEX = /^[0-9a-f]+$/;

export function isLowercaseHex(s: string): boolean {
  return LOWERCASE_HEX.test(s);
}

export function isValidScriptPubKey(s: string | null | undefined): s is string {
  return (
    s !== null &&
    s !== undefined &&
    s.length > 0 &&
    s.length % 2 === 0 &&
    LOWERCASE_HEX.test(s)
  );
}

export function asScriptPubKey(s: string): ScriptPubKey {
  if (!isValidScriptPubKey(s)) {
    throw new Error(`invalid scriptPubKey (expected non-empty lowercase hex, even length)`);
  }
  return s as ScriptPubKey;
}

export function asDomainId(n: number): DomainId {
  if (!Number.isInteger(n) || n < 0) {
    throw new Error(`invalid domainId: ${String(n)}`);
  }
  return n as DomainId;
}

export function shortenHex(s: string, head = 6, tail = 4): string {
  if (s.length <= head + tail + 1) return s;
  return `${s.slice(0, head)}…${s.slice(-tail)}`;
}
